import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { isInternal } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(
    localStorage.getItem("fiskal_client") || ""
  );

  const loadClients = useCallback(async () => {
    try {
      const { data } = await api.get("/clients");
      setClients(data);
      if (data.length && !localStorage.getItem("fiskal_client")) {
        setSelectedClientId(data[0].id);
        localStorage.setItem("fiskal_client", data[0].id);
      }
    } catch (e) { console.error("loadClients failed", e); }
  }, []);

  const bootstrap = useCallback(async () => {
    const token = localStorage.getItem("fiskal_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadClients();
    } catch (e) {
      localStorage.removeItem("fiskal_token");
      setUser(false);
    }
  }, [loadClients]);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fiskal_token", data.token);
    setUser(data.user);
    if (!isInternal(data.user.role)) {
      setSelectedClientId(data.user.client_id);
      localStorage.setItem("fiskal_client", data.user.client_id);
    }
    await loadClients();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("logout failed", e); }
    localStorage.removeItem("fiskal_token");
    setUser(false);
  };

  const selectClient = (id) => {
    setSelectedClientId(id);
    localStorage.setItem("fiskal_client", id);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, clients, selectedClientId, selectClient, loadClients, reloadUser: bootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}
